import React from "react";
//images
import inst from "../../../../../assets/images/redesign/signup-react/footer/ig.svg";
import fb from "../../../../../assets/images/redesign/signup-react/footer/facebook.svg";
import mail from "../../../../../assets/images/redesign/signup-react/footer/pinterest.svg";
import tw from "../../../../../assets/images/redesign/signup-react/footer/twitter.svg";
import youtube from "../../../../../assets/images/redesign/signup-react/footer/youtube.svg";
import SVG from "react-inlinesvg";

const FOOTER_LINKS = [
  {
    label: "How It Works",
    link: "how_it_works"
  },
  {
    label: "About Us",
    link: "about_us"
  },
  {
    label: "Partners",
    link: "partners"
  },
  {
    label: "Terms of Service",
    link: "tos"
  },
  {
    label: "Privacy Policy",
    link: "privacy"
  },
  {
    label: "Investors",
    link: "https://investors.pinchme.com"
  },
  {
    label: "Help Center",
    link: "https://helpcenter.pinchme.com",
    styles: "pw-footer-landing-container--border-none"
  }
];

function Footer() {
  return (
    <div className="pw-footer-landing-container pw-container">
      <h1 className="pw-footer-landing-container--title">Connect with us</h1>
      <div className="pw-footer-landing-container--img-main">
        <a
          href={"http://instagram.com/PINCHme"}
          className="pw-footer-landing-container--img-links-container"
        >
          <SVG width={35} height={35} className="pw-inst-svg" src={inst} />
        </a>
        <a
          href={"https://www.facebook.com/PINCHme"}
          className="pw-footer-landing-container--img-links-container"
        >
          <SVG width={35} height={35} className="pw-fb-svg" src={fb} />
        </a>
        <a
          href={"https://www.youtube.com/user/PINCHmeUS"}
          className="pw-footer-landing-container--img-links-container"
        >
          <SVG
            width={35}
            height={35}
            className="pw-youtube-svg"
            src={youtube}
          />
        </a>
        <a
          href={"https://www.pinterest.com/PINCHme/"}
          className="pw-footer-landing-container--img-links-container"
        >
          <SVG width={35} height={35} className="pw-mail-svg" src={mail} />
        </a>
        <a
          href={"https://www.twitter.com/PINCHme"}
          className="pw-footer-landing-container--img-links-container"
        >
          <SVG width={35} height={35} className="pw-tw-svg" src={tw} />
        </a>
      </div>

      <div className="pw-footer-landing-container--links-container">
        {FOOTER_LINKS.map(({ label, styles, link }) => (
          <a key={label} className={styles} href={link}>
            {label}
          </a>
        ))}
      </div>

      <p className="pw-footer-landing-container--rights-reserved">
        © PINCHme 2020. All Rights Reserved
      </p>
    </div>
  );
}

export default Footer;
